// ------------------ config (static)
/* eslint-disable-next-line no-unused-vars */
const Checkout = (() => {
	// private var(s)
	const _cartconfig = {
		selectedTimeSlot: ""
	};

	const _digitalDataConfig = {
		placeOrderButton: {
			buttonName: "注文を確定する",
			buttonType: "internal",
			buttonPosition: "2",
	},
	 addressButton : {
		buttonName: "更新",
		buttonType: "external",
		buttonPosition: "1",
	}
	}

	// private method(s)
	const _constructor = () => {
		// console.log('Config is running');
	};

	_constructor();

	// output/public
	return {
		cartConfig: _cartconfig,
		digitalDataConfig: _digitalDataConfig,
	};
})();
